module.exports = __webpack_public_path__ + "static/media/logo.168c28f9.svg";